import { Flex, Image } from "@chakra-ui/react"

const Navbar = () => {
  return (
    <Flex alignItems="center" justifyContent="left">
      <Image
        src="/cez-confort-asigurat/assets/logo-my-cez.png"
        alt="Logo My CEZ"
        marginTop="12px"
        marginBottom="12px"
        marginLeft="10vw"
        marginRight="10vw"
        onClick={(e) => {
          e.preventDefault()
          window.location.href = "https://mycez.cezinfo.ro/home/"
        }}
        _hover={{ cursor: "pointer" }}
      />
    </Flex>
  )
}

export default Navbar
